import BRTR_EXT_1 from "./BRTR_EXT_1";

export default {
  BRTR_EXT_1,
};
